import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

/** Toasts in the festival's colours (see `.site-toaster` in tailwind.css). */
const EpicToaster = ({ theme, ...props }: ToasterProps) => {
	return <Sonner theme={theme} className="site-toaster" {...props} />
}

export { EpicToaster }
